var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmergencyPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "42px",
    viewBox: "0 0 33 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Emergency Pin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-34.6%",
    y: "-15.5%",
    width: "169.2%",
    height: "131.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "L+M-Pin-Trial-v0-Copy",
    transform: "translate(-227.000000, -487.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(61.000000, 172.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(154.000000, 61.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 252.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14-Copy",
    transform: "translate(14.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shadow",
    fillOpacity: 0.3,
    fill: "#000000",
    filter: "url(#filter-1)",
    transform: "translate(14.500000, 32.500000) rotate(-270.000000) translate(-14.500000, -32.500000) ",
    points: "12 18 21 39 16 47 8 28"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill",
    fill: "#E6001C",
    transform: "translate(8.000000, 20.000000) rotate(-270.000000) translate(-8.000000, -20.000000) ",
    points: "-7 12 23 12 28 20 23 28 -7 28 -12 20"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "White-Counter",
    fill: "#FFFFFF",
    transform: "translate(8.000000, 20.000000) rotate(-270.000000) translate(-8.000000, -20.000000) ",
    points: "-5.5 16 21.5 16 24 20 21.5 24 -5.5 24 -8 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7228762,12.5 L27.4103762,20 L22.7228762,27.5 L-6.72287618,27.5 L-11.4103762,20 L-6.72287618,12.5 L22.7228762,12.5 Z",
    id: "Stroke",
    stroke: "#FFFFFF",
    opacity: 0.75,
    transform: "translate(8.000000, 20.000000) rotate(-270.000000) translate(-8.000000, -20.000000) "
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyPin);
export default __webpack_public_path__ + "static/media/emergency-pin.23385930d25282062626efd80c571fda.svg";
export { ForwardRef as ReactComponent };